import { useState } from "react";
import { useGetSuccessfulBiddersApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import TenderSearchBar from "../../components/TenderSearchBar";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";

import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import PaginationNew from "../../components/Pagination/PaginationNew";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { convertDateFormat } from "../../Utils/utils";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../../components/PdfZipItem";

const SuccessfulBidders = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const {
    data: successfulBiddersData = {},
    isLoading: queriesIsLoading,
    isFetching: queriesIsFetching,
  } = useGetSuccessfulBiddersApiQuery({
    page: currentPage,
    title: searchTerm,
    lang: languageType,
  });

  useTableResponsive(successfulBiddersData?.tenders || []);

  const lastUpdatedOn = successfulBiddersData?.tenders?.[0]?.changed_date;

  // console.log(successfulBiddersData.pagination.total_pages);

  const totalPages = successfulBiddersData?.pagination?.total_pages - 1;

  const handleSubmitSearch = (inputText) => {
    setCurrentPage(0);
    setSearchTerm(inputText);
  };

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (queriesIsLoading || queriesIsFetching) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Tender", "निविदा")}
        titleLink="/tender/successful-bidders"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 d-flex justify-content-between mb-3">
                <TenderSearchBar
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  title={getText("Tender Number", "निविदा संख्या")}
                  setCurrentPage={setCurrentPage}
                  handleSubmitSearch={handleSubmitSearch}
                />
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        {/* <th>Sr.&nbsp; No.</th> */}
                        <th>{getText("Tender Number", "निविदा संख्या")}</th>
                        <th>{getText("Tender Date", "निविदा दिनांक")}</th>
                        <th>{getText("Tender Description", "निविदा विवरण")}</th>
                        <th>
                          {getText("Successful Bidders", "सफल बोलीकर्ताओं")}
                        </th>
                        <th>{getText("Remarks", "टिप्पणियों")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {successfulBiddersData?.tenders?.length > 0 ? (
                        successfulBiddersData?.tenders?.map((item, index) => (
                          <tr key={index}>
                            <td
                              className="no-wrap-td"
                              data-key={getText(
                                "Tender Number",
                                "निविदा संख्या",
                              )}
                            >
                              <PdfZipItem
                                filePath={item?.uri}
                                title={item.title}
                                filesize={item.file_size}
                              />
                            </td>
                            <td
                              className="no-wrap-td"
                              data-key={getText("Tender Date", "निविदा दिनांक")}
                            >
                              {convertDateFormat(item.field_tender_date_value)}
                            </td>
                            <td
                              data-key={getText(
                                "Tender Description",
                                "निविदा विवरण",
                              )}
                            >
                              <p
                                dangerouslySetInnerHTML={{
                                  __html:
                                    item.field_short_notice_inviting_bids_value,
                                }}
                              />
                            </td>
                            <td
                              data-key={getText(
                                "Successful Bidders",
                                "सफल बोलीकर्ताओं",
                              )}
                            >
                              {Array.isArray(item.successful_bidder) &&
                                item.successful_bidder.map((subitem, i) => (
                                  <PdfZipItem
                                    key={i}
                                    filePath={subitem?.file.file_uri}
                                    title={subitem.file.file_description}
                                    filesize={subitem.file.file_size}
                                  />
                                ))}
                            </td>
                            <td data-key={getText("Remarks", "टिप्पणियों")}>
                              {/* {item.successful_bidder &&
                                item?.successful_bidder?.files?.map(
                                  (subitem, i) => (
                                    <div className="d-flex" key={i}>
                                      <div>{subitem.field_remarks_value}</div>
                                    </div>
                                  ),
                                )} */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <PaginationNew
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  totalPages={totalPages}
                />
              </div>
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessfulBidders;
